import { PageRoot } from './Page'
import { PageContent } from './PageContent'
import { PageListLoader, PageLoader } from './loader'

export type { PageContentColumnProps, PageContentProps, PageProps } from './types'
export type { PageLoaderProps, PageListLoaderProps } from './loader'

export { PageContentContext } from './PageContent'

export const Page = Object.assign(PageRoot, {
  Content: PageContent,
  Loader: PageLoader,
  ListLoader: PageListLoader,
})
